<chart *ngIf="showChart; else waitingOnPlanning" [dataSet]="chartData" (onClick)="bubbleClick($event)" [plugins]="chartPlugins" chartType="horizontalBar" width="90%" [chartLabels]="chartLabels" [options]="chartOptions"></chart>

<ng-template #waitingOnPlanning>
  <div>
    <h4 class="text-center text-muted p-4 m-4">Awaiting Planning</h4>
    <p class="text-center text-muted"><i class="fas fa-fw fa-lg text-info fa-info-circle"></i>The preliminary waterfall chart for this part will be available once planning is finished.</p>
  </div>
</ng-template>
